import businessAreaUtils from "./businessArea/BusinessAreaUtils";

export default {

  addBackground: function(id) {
    document.getElementsByTagName("html")[0].classList.add('main-with-background');
    document.getElementsByTagName("main")[0].style = "background-image: url('" + id + "')";
  },

  removeBackground: function () {
    document.getElementsByTagName("html")[0].classList.remove('main-with-background');
  },

  getUrlBusinessAreaImage(id) {
    return businessAreaUtils.apiUrl() + '/f/businessAreaLogo/' + id;
  }
}



// WEBPACK FOOTER //
// ./src/app/utils.js